import { render, staticRenderFns } from "./Sidebar-left.vue?vue&type=template&id=632b1893&scoped=true&lang=pug"
import script from "./Sidebar-left.vue?vue&type=script&lang=js"
export * from "./Sidebar-left.vue?vue&type=script&lang=js"
import style0 from "./Sidebar-left.vue?vue&type=style&index=0&id=632b1893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632b1893",
  null
  
)

export default component.exports